import { apiClient } from "../api/apiClient";
import QueryHelpers from "../../utils/queryHelpers";

const getCategories = () => apiClient.get(`/event-categories`);
const createCategory = (name) => apiClient.post(`/event-categories`, { name }, { requiresAuth: true });
const updateCategory = (id, name) => apiClient.put(`/event-categories/${id}`, { name }, { requiresAuth: true });
const deleteCategory = (id) => apiClient.delete(`/event-categories/${id}`, { requiresAuth: true });
const getHashtags = () => apiClient.get(`/events/hashtags`);

const getAllEvents = (args) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const params = {
        page: args.page ?? 1,
        pageSize: args.pageSize ?? 10,
        title: args.search ?? '',
        createdFrom: args.createdFrom ?? '2025-01-01',
        createdTo: args.createdTo ?? '2030-01-01',
        sort: args.sort ?? 'createdAt_desc',
    }
    if (!user.roles?.includes('ADMIN')) {
        params.userId = user?.id;
    }
    if (args.dateFrom) {
        params.dateFrom = args.dateFrom;
    }
    if (args.dateTo) {
        params.dateTo = args.dateTo;
    }

    const query = QueryHelpers.buildQueryString(params);
    return apiClient.get(`/events?${query}`);
}

const register = (id, fullName, email) => {
    const body = {
        eventId: id,
        fullName,
        email
    }
    return apiClient.post(`/events/${id}/participants`, body, {
        requiresAuth: true,
    });
}

const contact = (values) =>
    apiClient.post(`/contact`, values);

const getEvent = (id) =>
    apiClient.get(`/events/${id}`, { requiresAuth: true });

const getEventParticipants = (id) =>
    apiClient.get(`/events/${id}/participants`, { requiresAuth: true });

const deleteEventParticipant = (eventId, id) =>
    apiClient.delete(`/events/${eventId}/participants/${id}`, { requiresAuth: true });

const create = (event) => {
    const form = {
        title: event.title,
        parentEventTitle: event.parentTitle || null,
        address: event.address,
        startDate: event.startDate,
        startTime: event.startTime,
        endDate: event.endDate,
        endTime: event.endTime,
        maxParticipants: parseInt(event.maxParticipants) || 0,
        description: event.description || null,
        coverImage: event.coverImage,
        originalCoverImageName: event.coverImageName,
        isOnline: event.isOnline,
        isFree: event.isFree,
        showFreeSlotsInfo: event.showFreeSlotsInfo,
        directions: event.directions,
        url: event.url,
        platform: event.platform,
        categories: event.categories,
        hashtags: event.hashtags,
        host: event.host,
        ticketTypes: event.tickets
    };

    return apiClient.post('/events', form, { requiresAuth: true });
}

const update = (event) => {
    const form = {
        id: event.id,
        title: event.title,
        parentEventTitle: event.parentTitle || null,
        address: event.address,
        startDate: event.startDate,
        startTime: event.startTime,
        endDate: event.endDate,
        endTime: event.endTime,
        maxParticipants: parseInt(event.maxParticipants) || 0,
        description: event.description || null,
        coverImage: event.coverImage,
        originalCoverImageName: event.coverImageName,
        isOnline: event.isOnline,
        isFree: event.isFree,
        showFreeSlotsInfo: event.showFreeSlotsInfo,
        directions: event.directions,
        url: event.url,
        platform: event.platform,
        categories: event.categories,
        hashtags: event.hashtags,
        host: event.host,
        ticketTypes: event.tickets
    };

    return apiClient.put(`/events/${event.id}`, form, { requiresAuth: true });
}

const deleteEvent = (id) =>
    apiClient.delete(`/events/${id}`, { requiresAuth: true });

const uploadCoverImage = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return apiClient.post('/events/upload', formData, {
        requiresAuth: true,
        headers: {
            'Content-Type': undefined,
        },
    });
};

const getOrderTickets = (orderId) =>
    apiClient.get(`/orders/${orderId}/tickets`, { requiresAuth: true });

const markTicketAttended = (ticketId, attended) =>
    apiClient.patch(`/tickets/${ticketId}/attended`, { attended }, { requiresAuth: true });

export default {
    getCategories,
    createCategory,
    updateCategory,
    deleteCategory,
    getHashtags,
    getAllEvents,
    getEvent,
    register,
    contact,
    getEventParticipants,
    deleteEventParticipant,
    create,
    update,
    deleteEvent,
    uploadCoverImage,
    retryKsefInvoice: (orderId) => apiClient.post(`/orders/${orderId}/ksef/retry`, {}, { requiresAuth: true }),
    getOrderTickets,
    markTicketAttended,
}
